import styled from 'styled-components';

/** Wrapper 12 col, mobile 8 */
export const SectionGrid = styled.section<{ $max?: number }>`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  column-gap: 40px;
  max-width: 100%
  margin: 0 auto;
  width: 100%;

  @media (max-width: 1080px) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
    column-gap: 16px;
    padding: 0 20px;
    max-width: 100%;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
    column-gap: 14px;
    padding: 0 0;
  }
`;

export const Full = styled.div`
  grid-column: 1 / -1;
`;

export const GridSpan = styled.div<{ start?: number; span?: number }>`
  grid-column: ${({ start = 1, span = 12 }) => `${start} / span ${span}`};
  width: 100%;

  @media (max-width: 768px) {
    grid-column: 1 / -1;
  }
`;
